/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_DescriptionInputs */

const en_paste_attributes_description = /** @type {(inputs: Paste_Attributes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select attributes to paste from clipboard`)
};

const fr_paste_attributes_description = /** @type {(inputs: Paste_Attributes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez les attributs a coller depuis le presse-papiers`)
};

const de_paste_attributes_description = /** @type {(inputs: Paste_Attributes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Attribute aus, die aus der Zwischenablage eingefügt werden sollen.`)
};

const it_paste_attributes_description = /** @type {(inputs: Paste_Attributes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona gli attributi da incollare dagli appunti`)
};

const ru_paste_attributes_description = /** @type {(inputs: Paste_Attributes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите атрибуты для вставки из буфера обмена.`)
};

const es_paste_attributes_description = /** @type {(inputs: Paste_Attributes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar atributos para pegar desde el portapapeles`)
};

const zh_cn2_paste_attributes_description = /** @type {(inputs: Paste_Attributes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要从剪贴板粘贴的属性`)
};

const ja_paste_attributes_description = /** @type {(inputs: Paste_Attributes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリップボードから貼り付ける属性を選択`)
};

const hi_paste_attributes_description = /** @type {(inputs: Paste_Attributes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लिपबोर्ड से पेस्ट करने के लिए एट्रिब्यूट चुनें`)
};

const pt_pt2_paste_attributes_description = /** @type {(inputs: Paste_Attributes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione os atributos que deseja colar da área de transferência.`)
};

/**
* | output |
* | --- |
* | "Select attributes to paste from clipboard" |
*
* @param {Paste_Attributes_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_description = /** @type {((inputs?: Paste_Attributes_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_description(inputs)
	if (locale === "de") return de_paste_attributes_description(inputs)
	if (locale === "it") return it_paste_attributes_description(inputs)
	if (locale === "ru") return ru_paste_attributes_description(inputs)
	if (locale === "es") return es_paste_attributes_description(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_description(inputs)
	if (locale === "ja") return ja_paste_attributes_description(inputs)
	if (locale === "hi") return hi_paste_attributes_description(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_description(inputs)
	return en_paste_attributes_description(inputs)
});